<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002164')" prop="status">
              <Select v-model="pageParams.status">
                <Option v-for="item in enableStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001437')" prop="name">
              <Input :placeholder="$t('key1002165')" v-model.trim="pageParams.name"></Input>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" icon="md-search" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--新增规则-->
      <Button type="primary" @click="addRulesBtn" v-if="getPermission('ymsWarehouseAutoRule_insert')">{{ $t('key1002166') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        draggable
        max-height="520"
        @on-drag-drop="dragDrop"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--自动分仓规则弹窗-->
    <automaticWarehouseRulesModal ref="automaticWarehouse" @updateData="search()"></automaticWarehouseRulesModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import automaticWarehouseRulesModal from "@/views/yms/components/basicSettings/automaticWarehouseRulesModal";
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";

export default {
  name: "automaticDistributionRules",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        status: 'null',
        name: ''
      },
      tableColumns: [
        {
          title: 'No.',
          type: 'index',
          width: 65,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002152'),
          width: 200,
          align: 'center',
          render: (h, params) => {
            let arr = [
              h('span', {
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002153')
                },
                domProps: {
                  innerHTML: '&#xe68a;'
                },
                class: 'icon iconfont cursor greenColor',
                style: {
                  fontSize: '18px',
                  margin: '0 4px'
                },
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, v.tableData.length - 1, params.index);
                  }
                }
              }),
              h('span', {
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002154')
                },
                domProps: {
                  innerHTML: '&#xe687;'
                },
                class: 'icon iconfont cursor blueColor',
                style: {
                  fontSize: '18px',
                  margin: '0 4px'
                },
                on: {
                  click: () => {
                    v.tableSort(params.row.autoRuleId, 0, params.index);
                  }
                }
              }),
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 20
                },
                attrs: {
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002155')
                },
                style: {
                  marginLeft: '5px',
                  position: 'relative',
                  top: '-2px'
                },
                class: 'cursor-move grayColor'
              })
            ];
            if (params.index === 0) {
              arr.splice(1, 1);
            } else if (params.index === v.tableData.length - 1) {
              arr.splice(0, 1);
            }
            if (v.tableData.length > 1) {
              return v.getPermission('ymsPackageDeclareAutoRule_updatePriority') ? h('div', {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              }, arr) : '';
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002156'),
          align: 'center',
          key: 'name'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002157'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            if (status !== undefined) {
              let typeList = [
                {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
                {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
              ];
              return h('Badge', {
                props: {
                  status: typeList[status].type,
                  text: typeList[status].text
                }
              });
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'center',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002160'),
          key: 'updatedTime',
          align: 'center',
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 160,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['automaticWarehouse'].automaticWarehouseRules('look', params.row.autoRuleId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsWarehouseAutoRule_update'),
                    clickFn: () => {
                      v.$refs['automaticWarehouse'].automaticWarehouseRules('edit', params.row.autoRuleId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003'),
                    show: v.getPermission('ymsWarehouseAutoRule_update'),
                    clickFn: () => {
                      v.$refs['automaticWarehouse'].automaticWarehouseRules('copy', params.row.autoRuleId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsWarehouseAutoRule_delete'),
                    clickFn: () => {
                      v.deleteRuleBtn([params.row.autoRuleId]);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      enableStatusList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 'null'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'), value: 1},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'), value: 0},
      ],
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await this.getList();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.getList();
    },
    // 列表查询
    getList() {
      let v = this;
      v.tableData = [];
      if (v.getPermission('ymsWarehouseAutoRule_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsWarehouseAutoRule_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data || [];
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 优先级拖拽排序
    dragDrop(a, b) {
      this.tableSort(this.tableData[a].autoRuleId, b, a);
    },
    // 处理拖拽排序
    tableSort(autoRuleId, index, oldIndex) {
      let v = this;
      let obj = {
        currentId: autoRuleId, // 规则ID
        previousId: index ? v.tableData[index].autoRuleId : null, // 前一个
        businessId: v.tableData[oldIndex].businessId
      };
      if (!index && v.tableData.length > 1) {
        obj.nextId = v.tableData[0].autoRuleId;
      }
      if (oldIndex > index) {
        obj = {
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          businessId: v.tableData[oldIndex].businessId,
          previousId: index > 0 ? v.tableData[index - 1].autoRuleId : null
        };
        if (index >= 0 && index !== v.tableData.length - 1) {
          obj.nextId = v.tableData[index + 1].autoRuleId;
        }
      } else {
        obj = {
          currentId: v.tableData[oldIndex].autoRuleId, // 规则ID
          businessId: v.tableData[oldIndex].businessId,
          previousId: index > 0 ? v.tableData[index].autoRuleId : null
        };
        if (index >= 0 && index !== v.tableData.length - 1) {
          obj.nextId = v.tableData[index + 1].autoRuleId;
        }
      }
      v.axios.put(api.put_ymsWarehouseAutoRule_updatePriority, JSON.stringify(obj),
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.pageParamsStatus = true;
          v.getList();
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
        }
      });
    },
    // 新增规则
    addRulesBtn() {
      this.$refs['automaticWarehouse'].automaticWarehouseRules('add', null);
    },
    // 删除规则
    deleteRuleBtn(autoRuleIds) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002162'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002163'),
        onOk: () => {
          v.axios.delete(api.delete_ymsWarehouseAutoRule + '?autoRuleIds=' + autoRuleIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    automaticWarehouseRulesModal
  }
};
</script>

<style lang="less" scoped>

</style>